export enum EditorEvent {
  Ready,
  ModelChange,
  ScrollTop,
  ScrollChange,
  ConfigChange,
  CodeChange,
  SelectionChange,
  CursorChange,
  Save,
}
